import { createApp } from 'vue';
import App from './App.vue';
import axios from 'axios';
import api from './api/api';
import router from './router';
import global from './assets/resource/js/global';
import store from './store/store';
import components from '@/components/index.js';
import { authCheckUrls } from './router/authCheckUrls';
import { noAuthCheckUrls } from './router/noAuthCheckUrls';
import Quasar from 'quasar';

if (Kakao) Kakao.init('9297437412d497f674763ae27a6619bb');

let lang = location.pathname.split('/')[1] ? location.pathname.split('/')[1] : 'kr';
const langArr = ['kr', 'en', 'ru', 'mn', 'ar', 'zh'];
if (!langArr.includes(lang)) lang = 'kr';

// 엄마아기
let host = 'H0009';
let hostNm = '혈액암병원';

let hostName = location.hostname.split('.')[0];

if(hostName == 'localhost' || hostName == '192') {
    hostName = 'blood';
}

if (hostName == 'aorta') {
    host = 'H0006';
    hostNm = '대동맥혈관병원';
} else if (hostName == 'ewhabrain') {
    host = 'H0007';
    hostNm = '뇌혈관병원';
} else if (hostName == 'mombaby') {
    host = 'H0008';
    hostNm = '엄마아기병원';
} else if (hostName == 'blood') {
    host = 'H0009';
    hostNm = '혈액암병원';
}
document.title = '이대' + hostNm;
store.commit('setLang', lang); // 다국어구분
store.commit('setHost', host); // 센터구분
store.commit('setHostNm', hostNm); // 병원구분
store.commit('setHostName', hostName); // 병원구분

const app = createApp(App);

// 전역화
app.config.globalProperties.axios = axios;
app.config.globalProperties.api = api;

Object.keys(components).forEach(name => {
    app.component(name, components[name]);
});

//라우트 가드
router.beforeEach((to, from, next) => {
    const isBlocked = authCheckUrls.some(url => to.path.indexOf(url) > -1);
    const isUnBlocked = noAuthCheckUrls.some(url => to.path.indexOf(url) > -1);

    if (!isUnBlocked) store.commit('setPrevUrl', to.fullPath);

    if (!store.getters.getStatus && isBlocked) {
        alert('로그인 후 이용이 가능합니다.');

        let url = '/kr/login';
        next(url);
    } else if (store.getters.getStatus && isUnBlocked) {
        alert('로그인이 되어 있습니다.\n로그아웃 후 이용이 가능합니다.');

        let url = '/';
        next(url);
    } else {
        next();
    }
});

axios.get('/menu.do', { params: { lang: lang, hospId: host } }).then(res => {
    app.config.globalProperties.menuList = res.data;
    app.use(router).use(global).use(store).use(Quasar).mount('#app');
});
